import { toPromptScopeQueryParam } from "constants/promptScopeFilter";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

export const useUpdatePromptMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) =>
        api.put(`${API_ROUTES.UPDATE_RENTAL_PROMPT}/${data?.id}`, {
          name: data?.name,
          description: data?.description,
          organizationStyleId: data?.organizationStyleId ?? null,
          styleId: data?.styleId ?? null,
        }),
      onSuccess: () => {
        showToast("success", "Prompt updated successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: [API_ROUTES.GET_RENTAL_PROMPT],
        });
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useGetPromptQuery = (params = {}) => {
  const { organizationStyleId, styleId, name, description } = params;
  const filterOrgId = toPromptScopeQueryParam(organizationStyleId);
  const filterStyleId = toPromptScopeQueryParam(styleId);
  const { data, isPending, isError, error } = useQuery({
    queryKey: [
      API_ROUTES.GET_RENTAL_PROMPT,
      { organizationStyleId, styleId, name, description },
    ],
    queryFn: () =>
      api.get(API_ROUTES.GET_RENTAL_PROMPT, {
        params: {
          ...(name && { name }),
          ...(description && { description }),
          ...(filterOrgId !== undefined && {
            organizationStyleId: filterOrgId,
          }),
          ...(filterStyleId !== undefined && { styleId: filterStyleId }),
        },
      }),
  });
  return { data: data?.data?.data ?? [], isPending, isError, error };
};

export const useAddPromptMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) =>
        api.post(API_ROUTES.ADD_RENTAL_PROMPT, {
          name: data?.name,
          description: data?.description,
          organizationStyleId: data?.organizationStyleId ?? null,
          styleId: data?.styleId ?? null,
        }),
      onSuccess: () => {
        showToast("success", "Prompt added successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: [API_ROUTES.GET_RENTAL_PROMPT],
        });
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useDeletePromptMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (id) => api.delete(`${API_ROUTES.DELETE_RENTAL_PROMPT}/${id}`),
      onSuccess: () => {
        showToast("success", "Prompt deleted successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: [API_ROUTES.GET_RENTAL_PROMPT],
        });
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useGetOrganizationStylesQuery = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_ORGANIZATION_STYLES],
    queryFn: () => api.get(API_ROUTES.GET_ORGANIZATION_STYLES),
  });
  return { data: data?.data?.data ?? [], isPending, isError, error };
};
